<template>
  <div class="polarityPie">
    <div class="pie" ref="pie"></div>
  </div>
</template>

<script>
import { EventBus } from '../utils/eventBus'
export default {
  name: 'PolarityPie',
  props: {
    apiDataPieChart: Array
  },
  data() {
    return {
      myPie: ""
    }
  },
  watch: {
    apiDataPieChart: {
      handler(newVal, oldVal) {
        this.setOriginPie()
        this.setPie()
      }
    }
  },
  methods: {
    // 饼图初始化
    setOriginPie() {
      echarts.init(this.$refs.pie).dispose();
      this.myPie = echarts.init(this.$refs.pie);
      this.myPie.on('click', function (params) {
        EventBus.$emit("polarity", params.name=='正面'?'1':'0')
      })
    },
    // 设置饼图
    setPie() {
      this.myPie.setOption({
        // title: {
        //   text: "各行业分布情况",
        //   left: "center",
        // },
        color: ['#4471C0', '#EF7B32'],
        width: "95%",
        height: "100%",
        tooltip: {},
        title: {
          text: "极性统计",
          left: "center",
        },
        legend: {
          type: "scroll",
          orient: "vertical",
          left: "left",
          top: "center",
          data: this.apiDataPieChart,
        },
        series: [
          {
            // name: "该行业公司数量",
            type: "pie",
            // roseType: "radius",
            radius: [0, '60%'],
            data: this.apiDataPieChart,
            center: ["50%", "50%"],
            left: "center",
            top: "center",
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
            label: {
              show: false,
            },
          },
        ],
      });
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.polarityPie {
  width: 49.5%;
  margin-left: 5px;
  margin-top: 5px;
  background-color: white;
  padding-left: 10px;
  border-radius: 6px;
  padding-top: 10px;
  -webkit-box-shadow: -10px 9px 21px 0 rgba(128, 152, 213, 0.07);
  .pie {
    min-height: 250px;
    // width: 50%
  }
}
</style>
